module.exports = __webpack_public_path__ + "static/media/GT03_AT_Accommodation-Attributes.848262a8.csv";